import React, { Component } from 'react'
import {
  TableCell,
  TableRow,
  IconButton,
  TextField
} from '@material-ui/core'
import { DeleteRounded } from '@material-ui/icons'
import isEqual from 'react-fast-compare'

export class DriverTableRow extends Component {
  state = {
    value: ''
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState)
  }

  onChange = e => this.setState({ value: e.target.value })

  onFocus = e => this.setState({ value: e.target.value })

  onBlur = e => {
    const { setDriver } = this.props

    const id = e.target.name
    const value = e.target.value

    setDriver({ id, value: value.trim() })
    this.setState({ value: '' })
  }

  onDelete = id => () => {
    const { deleteDriver } = this.props

    deleteDriver({ id })
  }

  render() {
    const { classes, label, id, company } = this.props

    const value = this.state.value
      ? this.state.value
      : label

    return (
      <TableRow>
        <TableCell className={classes.tableCell} padding='dense'>
          <TextField
            fullWidth
            name={id}
            value={value}
            onBlur={this.onBlur}
            onFocus={this.onFocus}
            onChange={this.onChange}
          />
        </TableCell>
        <TableCell className={classes.tableCell} padding='dense'>
          {company}
        </TableCell>

        <TableCell padding='checkbox'>
          <IconButton onClick={this.onDelete(id)}>
            <DeleteRounded fontSize='small' />
          </IconButton>
        </TableCell>
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Drivers/components/DriverTableRow/DriverTableRow.js